import classNames from 'classnames';

import { Wizard } from '../../../components/Wizard/Wizard';
import { useFlag } from '../../../services/launchDarkly';
import ChooseCountry from '../ChooseCountryDialog/ChooseCountry';
import { EmailVerification } from '../EmailVerification/EmailVerification';
import { LogIn } from '../LogIn/LogIn';
import { ChooseCountryWizardStepRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryWizardStepRedesign';
import { EmailVerificationRedesign } from '../redesign-components/EmailVerificationRedesign/EmailVerificationRedesign';
import { LogInOptionsRedesign } from '../redesign-components/LogInOptionsRedesign/LogInOptionsRedesign';
import { WelcomeBonusRedesign } from '../redesign-components/WelcomeBonusRedesign/WelcomeBonusRedesign';
import { VerificationSuccess } from '../VerificationSuccess/VerificationSuccess';
import WelcomeBonusDialog from '../WelcomeBonusDialog/WelcomeBonusDialog';

import { authWizardWrapperStyle } from './constants';
import styles from './RedesignWizard.module.scss';
const DEFAULT_STEPS = [LogIn, EmailVerification, VerificationSuccess, WelcomeBonusDialog];

const STEPS_WITH_COUNTRY_SELECTION = [...DEFAULT_STEPS, ChooseCountry];

const STEPS_REDESIGN = [
  LogInOptionsRedesign,
  EmailVerificationRedesign,
  ChooseCountryWizardStepRedesign,
  WelcomeBonusRedesign,
];

export default function LogInWizard() {
  const isSignUpCountrySelectionEnabled = useFlag<boolean>('sign_up_flow_country_selection', false);
  const isSignUpUiRedesignEnabled = useFlag<boolean>('ui_redesign_registration_flow', false);

  const defaultSteps = isSignUpCountrySelectionEnabled ? STEPS_WITH_COUNTRY_SELECTION : DEFAULT_STEPS;

  const steps = isSignUpUiRedesignEnabled ? STEPS_REDESIGN : defaultSteps;

  return (
    <Wizard
      classNameSteps={classNames({
        [styles.redesignFlowSteps]: isSignUpUiRedesignEnabled,
      })}
      classNameStepWrapper={classNames({
        [styles.redesignFlowStepWrapper]: isSignUpUiRedesignEnabled,
      })}
      steps={steps}
      wizardFlowParams={{
        isRedesignSteps: isSignUpUiRedesignEnabled,
      }}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
}
